export const LoginByPasswordForm = {
  Password: 'password',
  PasswordHelperText: 'password-helper-text',
  LoginBtn: 'login-btn',
} as const;
